import { partnerApiRequest } from 'core/service-wrapper/partner-api/handler-request/service-request'
import { buildServiceWrapper } from 'core/service-wrapper/wrapper'
import { getToggles } from 'quick-quote/feature-toggles'

/**
 * @typedef {Awaited<ReturnType<import('./wrapper').buildServiceWrapper>>} ServiceWrapper
 * @typedef {Awaited<ReturnType<import('core/service-wrapper/legacy/service').createLegacyService>>} LegacyServiceWrapper
 * @typedef {Awaited<ReturnType<import('core/service-wrapper/partner-api/service').createPartnerApiService>>} PartnerApiServiceWrapper
 */

/**
 * @type {ServiceWrapper | null}
 */
let serviceWrapper = null

export async function createServiceWrapper() {
  if (serviceWrapper !== null) {
    return serviceWrapper
  }

  const { ENABLE_PARTNER_API } = getToggles()

  let usePartnerApi = false
  if (ENABLE_PARTNER_API) {
    usePartnerApi = await partnerApiRequest.checkAvailable()
  }

  serviceWrapper = await buildServiceWrapper(usePartnerApi)

  // eslint-disable-next-line no-console
  console.log('service wrapper use partner api: ', usePartnerApi)

  return serviceWrapper
}

/**
 * getServiceWrapper
 * @returns {ServiceWrapper}
 */
export function getServiceWrapper() {
  if (serviceWrapper === null) {
    throw Error('should call createServiceWrapper first')
  }
  return serviceWrapper
}
